export default __webpack_public_path__ + "static/media/linkedin-icon.dd1ae8e2.svg";